import { connectHits } from 'react-instantsearch-dom'
import React from 'react'
import { useSelector } from '~/store/hooks'

import LaboCard from '~/components/features/cards/laboCard'
import OrderHits from '~/utils/orderHits'

const Hits = ({ hits }) => {
  const mainTag = useSelector((state) => state.currentMainTag)
  const profile = useSelector((state) => state.currentprofile)

  const laboHits = OrderHits(
    hits.filter((hit) => hit.contentType === 'labo'),
    mainTag,
    profile,
  )

  return (
    <ul className="lg:w-full full-width-tablet flex overflow-auto lg:overflow-visible mb-12 md:mb-0">
      {laboHits.slice(0, 3).map((hit, i) => {
        return (
          <li key={hit.objectID} className="labo__labo-card">
            <LaboCard labo={hit} />
          </li>
        )
      })}
    </ul>
  )
}

const CustomHitsLabo = connectHits(Hits)

export default CustomHitsLabo
